import styled from 'styled-components';
import { Layout } from 'antd';
import { media } from '@app/styles/themes/constants';
import { Button } from '@app/components/common/buttons/Button/Button';

export const LayoutMaster = styled(Layout)`
  height: 100vh;
`;

export const LayoutMain = styled(Layout)`
  @media only screen and ${media.md} {
    margin-left: 80px;
  }

  @media only screen and ${media.xl} {
    margin-left: unset;
  }
`;

export const ButtonLayoutMain = styled(Button)`
  left: 15%;
  width: 70%;
  font-size: 4vh;
  height: 6vh;
  background-color: white;
  color: black;

  /* On phones the 50vw column leaves ~131px, too narrow for "Smart Audit" at 4vh: grow with the text instead. */
  @media (max-width: 767px) {
    left: 50%;
    width: auto;
    min-width: 70%;
    padding: 0 0.6em;
    transform: translateX(-50%);
    white-space: nowrap;
    font-size: min(4vh, 7vw);
  }

  :hover {
    color: rgb(4, 133, 253);
    border-color: rgb(4, 133, 253);
  }

  :active,
  :focus,
  :hover {
    background: white;
  }
`;
